import axios from 'axios';
import { SERVER_URL, RECRUITMENT_URL, RECRUITMENT_URL_PROD } from './Config';
import { getToken } from './Token';
import { store } from '../redux/storeConfig/store';

// import {withNavigation} from 're+act-navigation';
// import navigateFromOutside from '../../router/navigateFromOutside';

export const getRequestFromRecruit = async (url, params) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'GET',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
    params: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const getRequestFromRecruitProd = async (url) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'GET',
    url: RECRUITMENT_URL_PROD + url,
    headers: { Authorization: tokenLogin },
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const putRequestFromRecruit = async (url, params) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'PUT',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const postRequestFromRecruit = async (url, params) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'POST',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const deleteRequestFromRecruit = async (url) => {
  const tokenLogin = await getToken();
  return axios({
    method: 'DELETE',
    url: RECRUITMENT_URL + url,
    headers: { Authorization: tokenLogin },
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const getRequest = (url) => {
  return axios.get(SERVER_URL + url).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const postRequest = (url, params) => {
  return axios.post(SERVER_URL + url, params).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const postRequestWithToken = async (url, params) => {
  const token = await getToken();
  return axios({
    method: 'POST',
    url: SERVER_URL + url,
    headers: { Authorization: token },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const putRequestWithToken = async (url, params) => {
  const token = await getToken();
  return axios({
    method: 'PUT',
    url: SERVER_URL + url,
    headers: { Authorization: token },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

export const getRequestWithTokenExtra = (api_url, params) => {
  let header = { headers: { Authorization: getToken() } };
  return axios.get('http://54.171.109.31:8080/' + api_url, header);
};

export const getRequestWithToken = async (url) => {
  const token = await getToken();
  return axios({
    method: 'GET',
    url: SERVER_URL + url,
    headers: { Authorization: token },
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const putRequestMultipart = async (url, params) => {
  const token = await getToken();
  return axios({
    method: 'PUT',
    url: SERVER_URL + url,
    headers: { Authorization: token, 'Content-Type': 'multipart/form-data' },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const postRequestMultipart = async (url, params) => {
  const token = await getToken();
  return axios({
    method: 'POST',
    url: SERVER_URL + url,
    headers: { Authorization: token, 'Content-Type': 'multipart/form-data' },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};
export const deleteRequestWithToken = async (url, params) => {
  const token = await getToken();
  return axios({
    method: 'DELETE',
    url: SERVER_URL + url,
    headers: { Authorization: token },
    data: params,
  }).then((response) => {
    if (response.data.error) {
      throw response.data.error;
    } else {
      return response.data;
    }
  });
};

function InterceptorsRequest(config) {
  config.headers['Content-Type'] = 'application/json';
  // console.log(
  //   "API_REQUEST:\n URL:",
  //   config.url,
  //   "\nAuthorization:",
  //   config.headers.Authorization,
  //   "\nBody:",
  //   JSON.stringify(config.data)
  // );
  return config;
}

const _handleCommonError = (errorResponse) => {
  // TODO: Handle Error
  if (errorResponse.message) {
  }
};

const _interceptorsResponseError = (error) => {
  if (error && error.response && error.response.status)
    switch (error.response.status) {
      case 401:
        // removeToken();
        // will redirect to "login" when Unauthorised error will raise
        // navigateFromOutside.navigate('LoginScreen', 'Login');
        const dispatch = store.dispatch;
        dispatch({ type: 'LOGOUT_WITH_JWT', payload: {} });
        break;
      default:
        _handleCommonError(error);
        break;
    }
  else {
    //  alert(error);
  }
};

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    return InterceptorsRequest(config);
  },
  (error) => {
    console.log('API_REQUEST_ERROR:', error);
    _interceptorsResponseError(error);
    return Promise.reject(error.response);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // console.log(
    //   "\n\nAPI_RESPONSE:\nStatus:",
    //   // response.status,
    //   "\nData:",
    //   response.data,
    //   "\n\n"
    // );
    return response;
  },
  (error) => {
    console.log('API_RESPONSE_ERROR', JSON.stringify(error.message), 'asdads');
    console.log('API_RESPONSE', JSON.stringify(error.response), 'ghghghggh');
    _interceptorsResponseError(error);
    return Promise.reject(error);
  }
);
